import React from 'react'

const CommonButton = ({ label, onClick }) => {
  return (
    <button className="bg-primaryBtnColor hover:bg-primaryBtnHoverColor text-white px-4 py-2 rounded-md text-sm font-medium transition-colors duration-300 whitespace-nowrap" onClick={onClick}>
      {label}
    </button>
  )
}

export default CommonButton